export default __webpack_public_path__ + "static/media/merchant-logo.c1b78556.svg";